import { apiBaseUrl } from 'app/src/msw/moneytransfer/staticapi/apiBaseurl'
import { getTransferCreationMock } from 'app/src/msw/stories/transfers-stories-mock'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getTransfer = http.get<
  { transferId: string },
  object,
  moneytransferApi.TransferResponseWithUserInfo | moneytransferApi.ErrorModel
>(apiBaseUrl + '/transfers/:transferId', async ({ params }) => {
  console.log('MSW: getTransfer called with params:', params)

  const transferId = params.transferId

  const transferOrders = await (await fetch('./data/moneyTransfer/transfers.json')).json()

  const transferOrder = transferOrders.items.find((item: { orderId: string }) => item.orderId === transferId)

  if (!transferOrder) {
    const transferCreation = getTransferCreationMock
    return new HttpResponse(JSON.stringify(transferCreation), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return new HttpResponse(JSON.stringify(transferOrder), {
    status: 200,
    headers: {
      'Content-Type': 'application/json',
    },
  })
})
